var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"koin-loading"},[_c('LoaderBody'),_c('p',[_vm._v("Buscando as melhores opções de parcelamento para você")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }